import React from 'react';

import {
    Typography
} from '@material-ui/core';

import PanToolIcon from '@material-ui/icons/PanToolOutlined'

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 150,
        padding: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
    },
    image: {
        display: 'inline-block',
        marginTop: 50,
        width: '200px',
        height: '200px'
    }
}));

export const ForbiddenPage = (props) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Typography align="center" variant="h2">
                403: You are not allowed here
            </Typography>
            <br />
            <Typography align="center" variant="body1">
                You either tried some shady route or you came here by mistake. Whichever it is, you should not be here
            </Typography>
            <br />
            <PanToolIcon className={classes.image} />
        </div>
    );
}